// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.watchface-detail-page {
  background: var(--bg-primary);
  padding-top: 50px;
  transition: background-color 0.3s ease;
}

/* Top Bar */
.detail-top-bar {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0.5rem 1.5rem;
}

.detail-back-button {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.9rem;
  background: var(--bg-secondary);
  color: var(--text-primary);
  text-decoration: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  border: 1px solid var(--border-primary);
}

.detail-back-button:hover {
  background: var(--bg-tertiary);
  border-color: var(--accent-primary);
  transform: translateX(-3px);
}

/* Container */
.detail-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1.5rem 2rem;
}

/* Hero: Side-by-side layout */
.detail-hero {
  position: relative;
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 2rem;
  align-items: start;
  margin-bottom: 1.5rem;
  padding: 1.5rem;
  border-radius: 16px;
  overflow: hidden;
}

/* ── Hero background (side fade) ── */
.detail-hero-bg {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 160px;
  right: -1.5rem;
  background-size: cover;
  background-position: left center;
  background-repeat: no-repeat;
  opacity: 0;
  animation: hero-bg-fade-in 2s ease-out forwards;
  z-index: 0;
  pointer-events: none;
  -webkit-mask-image: linear-gradient(to right, transparent 0%, black 35%);
  mask-image: linear-gradient(to right, transparent 0%, black 35%);
}

.detail-hero-bg::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.4) 0%,
    rgba(0, 0, 0, 0.15) 60%,
    rgba(0, 0, 0, 0.1) 100%
  );
}

@keyframes hero-bg-fade-in {
  to { opacity: 1; }
}

/* ── "has-bg" overrides ── */
.detail-hero--has-bg .hero-image-col,
.detail-hero--has-bg .hero-info-col {
  position: relative;
  z-index: 1;
}

.detail-hero--has-bg .title-gradient {
  background: linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.detail-hero--has-bg .meta-item {
  color: rgba(255, 255, 255, 0.85);
}

.detail-hero--has-bg .store-link-btn {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.detail-hero--has-bg .russia-payment-warning {
  color: rgba(255, 255, 255, 0.9);
}

.hero-image-col {
  position: sticky;
  top: 0;
}

.image-wrapper-link {
  display: block;
  text-decoration: none;
  cursor: pointer;
}

.image-wrapper {
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  background: var(--bg-secondary);
  box-shadow: 0 8px 30px var(--shadow-primary);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.image-wrapper:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px var(--shadow-primary);
}

.product-cover-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
}

/* Info Column */
.hero-info-col {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 0.5rem;
}

.hero-primary-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
}

.hero-title {
  font-size: 2.8rem;
  font-weight: 800;
  margin: 0;
  line-height: 1.1;
  font-family: 'Inter', sans-serif;
}

.title-gradient {
  background: linear-gradient(135deg, var(--accent-primary) 0%, var(--accent-secondary) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: inline-block;
}

.hero-store-links {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.store-link-btn {
  padding: 0.6rem 1.4rem;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.store-btn-primary {
  background: var(--accent-primary);
  color: white;
}

.store-btn-primary:hover {
  background: var(--accent-hover);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
}

.store-btn-secondary {
  background: var(--accent-secondary);
  color: white;
}

.store-btn-secondary:hover {
  filter: brightness(1.1);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);
}

.hero-meta {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.meta-item {
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.8rem;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 20px;
  font-size: 0.8rem;
  color: var(--text-secondary);
  font-weight: 500;
}

/* Tabs Section */
.detail-tabs-section {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 0.5rem;
}

.russia-payment-warning {
  margin-top: 1rem;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  background: rgba(249, 115, 22, 0.1);
  border: 1px solid rgba(249, 115, 22, 0.8);
  color: #f97316;
  font-size: 0.9rem;
  line-height: 1.5;
}

/* Loading & Error States */
.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 1rem;
  text-align: center;
  padding: 2rem;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid var(--border-primary);
  border-top: 4px solid var(--accent-primary);
  border-radius: 50%;
}

.error-container h2 {
  color: var(--error);
  margin: 0;
}

.error-container p {
  color: var(--text-secondary);
  margin: 0;
}

.back-link {
  background: var(--accent-primary);
  color: white;
  text-decoration: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
  margin-top: 1rem;
}

.back-link:hover {
  background: var(--accent-hover);
  transform: translateY(-1px);
}

/* Tablet */
@media (max-width: 900px) {
  .detail-hero {
    grid-template-columns: 260px 1fr;
    gap: 1.5rem;
  }

  .hero-title {
    font-size: 2.2rem;
  }

  .hero-image-col {
    position: static;
  }
}

/* Mobile */
@media (max-width: 680px) {
  .watchface-detail-page {
    padding-top: 10px;
  }

  .detail-container {
    padding: 0 1rem 1.5rem;
  }

  /* Hero-Background auf Mobile deaktivieren */
  .detail-hero-bg {
    display: none;
  }

  .detail-hero {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 1rem;
    border-radius: 12px;
    align-items: flex-start;
  }

  .hero-image-col {
    max-width: 260px;
    margin: 0 auto 0.75rem;
  }

  .hero-info-col {
    text-align: center;
    align-items: center;
    gap: 0.4rem;
    padding-top: 0;
  }

  .hero-title {
    font-size: 1.8rem;
    line-height: 1.2;
  }

  .hero-primary-row {
    justify-content: center;
    gap: 0.5rem;
  }

  .hero-store-links {
    display: flex;
    gap: 0.4rem;
  }

  .store-link-btn {
    padding: 0.5rem 1.1rem;
    font-size: 0.85rem;
  }

  .hero-meta {
    display: flex;
    justify-content: center;
    gap: 0.4rem;
    flex-wrap: wrap;
  }

  .meta-item {
    padding: 0.25rem 0.7rem;
    font-size: 0.8rem;
  }

  .detail-tabs-section {
    padding: 0.25rem;
    border-radius: 12px;
  }

  .russia-payment-warning {
    margin-top: 0.5rem;
    font-size: 0.8rem;
    padding: 0.6rem 0.9rem;
  }
}

@media (max-width: 400px) {
  .hero-title {
    font-size: 1.5rem;
  }

  .hero-image-col {
    max-width: 220px;
  }

  .store-link-btn {
    padding: 0.45rem 0.9rem;
    font-size: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/WatchfaceDetailPage/WatchfaceDetailPage.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,+BAA+B;EAC/B,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,gCAAgC;EAChC,4BAA4B;EAC5B,UAAU;EACV,+CAA+C;EAC/C,UAAU;EACV,oBAAoB;EACpB,wEAAwE;EACxE,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;AACH;;AAEA;EACE,KAAK,UAAU,EAAE;AACnB;;AAEA,6BAA6B;AAC7B;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,4CAA4C;EAC5C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2FAA2F;EAC3F,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE;IACE,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,WAAW;AACX;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA,4CAA4C;EAC5C;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AACF","sourcesContent":[".watchface-detail-page {\n  background: var(--bg-primary);\n  padding-top: 50px;\n  transition: background-color 0.3s ease;\n}\n\n/* Top Bar */\n.detail-top-bar {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0.5rem 1.5rem;\n}\n\n.detail-back-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.4rem 0.9rem;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  text-decoration: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 0.85rem;\n  transition: all 0.3s ease;\n  border: 1px solid var(--border-primary);\n}\n\n.detail-back-button:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--accent-primary);\n  transform: translateX(-3px);\n}\n\n/* Container */\n.detail-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 1.5rem 2rem;\n}\n\n/* Hero: Side-by-side layout */\n.detail-hero {\n  position: relative;\n  display: grid;\n  grid-template-columns: 320px 1fr;\n  gap: 2rem;\n  align-items: start;\n  margin-bottom: 1.5rem;\n  padding: 1.5rem;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n/* ── Hero background (side fade) ── */\n.detail-hero-bg {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 160px;\n  right: -1.5rem;\n  background-size: cover;\n  background-position: left center;\n  background-repeat: no-repeat;\n  opacity: 0;\n  animation: hero-bg-fade-in 2s ease-out forwards;\n  z-index: 0;\n  pointer-events: none;\n  -webkit-mask-image: linear-gradient(to right, transparent 0%, black 35%);\n  mask-image: linear-gradient(to right, transparent 0%, black 35%);\n}\n\n.detail-hero-bg::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    to right,\n    rgba(0, 0, 0, 0.4) 0%,\n    rgba(0, 0, 0, 0.15) 60%,\n    rgba(0, 0, 0, 0.1) 100%\n  );\n}\n\n@keyframes hero-bg-fade-in {\n  to { opacity: 1; }\n}\n\n/* ── \"has-bg\" overrides ── */\n.detail-hero--has-bg .hero-image-col,\n.detail-hero--has-bg .hero-info-col {\n  position: relative;\n  z-index: 1;\n}\n\n.detail-hero--has-bg .title-gradient {\n  background: linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.detail-hero--has-bg .meta-item {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.detail-hero--has-bg .store-link-btn {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.detail-hero--has-bg .russia-payment-warning {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.hero-image-col {\n  position: sticky;\n  top: 0;\n}\n\n.image-wrapper-link {\n  display: block;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.image-wrapper {\n  width: 100%;\n  border-radius: 16px;\n  overflow: hidden;\n  background: var(--bg-secondary);\n  box-shadow: 0 8px 30px var(--shadow-primary);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.image-wrapper:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 40px var(--shadow-primary);\n}\n\n.product-cover-image {\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n  display: block;\n}\n\n/* Info Column */\n.hero-info-col {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding-top: 0.5rem;\n}\n\n.hero-primary-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.hero-title {\n  font-size: 2.8rem;\n  font-weight: 800;\n  margin: 0;\n  line-height: 1.1;\n  font-family: 'Inter', sans-serif;\n}\n\n.title-gradient {\n  background: linear-gradient(135deg, var(--accent-primary) 0%, var(--accent-secondary) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  display: inline-block;\n}\n\n.hero-store-links {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.store-link-btn {\n  padding: 0.6rem 1.4rem;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.store-btn-primary {\n  background: var(--accent-primary);\n  color: white;\n}\n\n.store-btn-primary:hover {\n  background: var(--accent-hover);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);\n}\n\n.store-btn-secondary {\n  background: var(--accent-secondary);\n  color: white;\n}\n\n.store-btn-secondary:hover {\n  filter: brightness(1.1);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);\n}\n\n.hero-meta {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.meta-item {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.3rem 0.8rem;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 20px;\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n/* Tabs Section */\n.detail-tabs-section {\n  background: var(--bg-primary);\n  border-radius: 16px;\n  padding: 0.5rem;\n}\n\n.russia-payment-warning {\n  margin-top: 1rem;\n  padding: 0.85rem 1rem;\n  border-radius: 10px;\n  background: rgba(249, 115, 22, 0.1);\n  border: 1px solid rgba(249, 115, 22, 0.8);\n  color: #f97316;\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n/* Loading & Error States */\n.loading-container,\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 1rem;\n  text-align: center;\n  padding: 2rem;\n}\n\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid var(--border-primary);\n  border-top: 4px solid var(--accent-primary);\n  border-radius: 50%;\n}\n\n.error-container h2 {\n  color: var(--error);\n  margin: 0;\n}\n\n.error-container p {\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.back-link {\n  background: var(--accent-primary);\n  color: white;\n  text-decoration: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n}\n\n.back-link:hover {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n}\n\n/* Tablet */\n@media (max-width: 900px) {\n  .detail-hero {\n    grid-template-columns: 260px 1fr;\n    gap: 1.5rem;\n  }\n\n  .hero-title {\n    font-size: 2.2rem;\n  }\n\n  .hero-image-col {\n    position: static;\n  }\n}\n\n/* Mobile */\n@media (max-width: 680px) {\n  .watchface-detail-page {\n    padding-top: 10px;\n  }\n\n  .detail-container {\n    padding: 0 1rem 1.5rem;\n  }\n\n  /* Hero-Background auf Mobile deaktivieren */\n  .detail-hero-bg {\n    display: none;\n  }\n\n  .detail-hero {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    padding: 1rem;\n    border-radius: 12px;\n    align-items: flex-start;\n  }\n\n  .hero-image-col {\n    max-width: 260px;\n    margin: 0 auto 0.75rem;\n  }\n\n  .hero-info-col {\n    text-align: center;\n    align-items: center;\n    gap: 0.4rem;\n    padding-top: 0;\n  }\n\n  .hero-title {\n    font-size: 1.8rem;\n    line-height: 1.2;\n  }\n\n  .hero-primary-row {\n    justify-content: center;\n    gap: 0.5rem;\n  }\n\n  .hero-store-links {\n    display: flex;\n    gap: 0.4rem;\n  }\n\n  .store-link-btn {\n    padding: 0.5rem 1.1rem;\n    font-size: 0.85rem;\n  }\n\n  .hero-meta {\n    display: flex;\n    justify-content: center;\n    gap: 0.4rem;\n    flex-wrap: wrap;\n  }\n\n  .meta-item {\n    padding: 0.25rem 0.7rem;\n    font-size: 0.8rem;\n  }\n\n  .detail-tabs-section {\n    padding: 0.25rem;\n    border-radius: 12px;\n  }\n\n  .russia-payment-warning {\n    margin-top: 0.5rem;\n    font-size: 0.8rem;\n    padding: 0.6rem 0.9rem;\n  }\n}\n\n@media (max-width: 400px) {\n  .hero-title {\n    font-size: 1.5rem;\n  }\n\n  .hero-image-col {\n    max-width: 220px;\n  }\n\n  .store-link-btn {\n    padding: 0.45rem 0.9rem;\n    font-size: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
